import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";
import principle03 from "./layouts/principle-03/principle";
import principle04 from "./layouts/principle-04/principle";
import principle05 from "./layouts/principle-05/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";
import task03 from "./layouts/task-03/task";

const lesson: Lesson = {
  id: "d6ff7dab-a334-4962-b566-483c4adeb8bf",
  publicId: "5",
  name: "Mechanical–acoustical-electrical analogies",
  difficulty: 1,
  contentTypes: { audio: false, interactive: true, video: false },
  body: [principle01, principle02, principle03, principle04, principle05, task01, task02, task03],
};

export default lesson;
